export const messages = {
  labels: {
    allergyType: {
      id: 'treatmentSummary.Groups.Allergy.AllergyType',
      defaultMessage: 'Type of Allergy: ',
    },
    onsetDate: {
      id: 'treatmentSummary.Groups.Allergy.OnsetDate',
      defaultMessage: 'Onset Date: ',
    },
    response: {
      id: 'treatmentSummary.Groups.Allergy.Response',
      defaultMessage: 'Response: ',
    },
    comment: {
      id: 'treatmentSummary.Groups.Allergy.Comment',
      defaultMessage: 'Comment: ',
    },
  },
};
